import * as app from '../namaapp'
import * as ts from '../common/Translator'
import {isArabic, translateId} from '../common/Translator'
import * as MenuTargetType from '../constants/MenuTargetType'
import * as ViewMode from '../constants/ViewMode'
import * as places from '../routing/places'
import {
    fetchTargetRecord,
    fetchTargetType,
    fixMenuAsSideBarFromGlobalConfig,
    getAutoDashBoardGroups,
    getDashboardsOfGroup,
    getRootReportGroups,
    isFeatureEnabled,
    isModuleLoaded,
    isModuleNotEmptyAndLoaded
} from "../login/ClientCache";
import {
    areAllEmptyOrNull,
    areEqual,
    areNotEqual,
    getFirstNotEmptyObj,
    isAnyEqualToFirst,
    isEmptyOrNull,
    isNotEmptyOrNull,
    nextId,
    noMenu
} from "../common/NamaCommon";
import {currentLoginInfo} from "../login/LoginPresenter";
import * as DomainBaseFieldIDs from "../constants/DomainBaseFieldIDs";
import {calcByLanguage} from "./treeView/TreeModelProvider";
import * as BSEntities from "../constants/BSEntities";
import {isMobileDevice} from "../common/GUIUtilities";

export let menuAPI;

export function render() {
    if (noMenu())
        return;
    if (menuAPI)
        return;
    let menu = app.instance.loginInfo.menu;
    let roots = menu.groups.filter((g) => g.rootGroup === true);
    for (let group_ of roots) {
        let childGroups_ = childGroups(menu, group_.code);
        expandGroupsIfAutoDashboards(childGroups_, menu);
        for (let childGroup of childGroups_) {
            let childItems_ = childItems(menu, childGroup.code);
            addMenuItems(menu, childGroup, childItems_);
        }
    }
    let rootGroups = constructMenuTree(menu);
    let menuElement = $("<nav id='mmenu'><ul/></nav>");
    let menuContainer = menuElement.find("ul");
    for (let rootGroup of rootGroups) {
        renderGroup(rootGroup, menuContainer);
    }
    let fixMenuAsSideBar_GlobalConfig = fixMenuAsSideBarFromGlobalConfig();
    let shouldFixMenuAsSideBar = fixMenuAsSideBar_GlobalConfig || localStorage.getItem("fixMenuAsSideBar") === "true";
    let shouldUseSubMenus = localStorage.getItem("shouldUseSubMenus") === "true";
    if (!fixMenuAsSideBar_GlobalConfig) {
        let checkbox = $(`<li><span><input type="checkbox" title="${translateId("youCanFixMenuFromGlobalConfigForAllUsers")}" ${shouldFixMenuAsSideBar ? "checked='true'" : ""} 
        id="fixMenuAsSideBar" class="k-checkbox k-checkbox-md k-rounded-md"/><label for="fixMenuAsSideBar" class="k-checkbox-label" title="${translateId("youCanFixMenuFromGlobalConfigForAllUsers")}">
        ${translateId("fixMenuAsSideBar")}</label></span></li>`);
        checkbox.find("#fixMenuAsSideBar").change(function () {
            if (this.checked)
                localStorage.setItem("fixMenuAsSideBar", "true");
            else
                localStorage.removeItem("fixMenuAsSideBar");
            location.reload();
        });
        checkbox.appendTo(menuContainer);
    }
    {
        let checkbox = $(`<li><span><input type="checkbox" title="${translateId("shouldUseSubMenus")}" ${shouldUseSubMenus ? "checked='true'" : ""} 
        id="shouldUseSubMenus" class="k-checkbox k-checkbox-md k-rounded-md"/><label for="shouldUseSubMenus" class="k-checkbox-label" title="${translateId("shouldUseSubMenus")}">
        ${translateId("shouldUseSubMenus")}</label></span></li>`);
        checkbox.find("#shouldUseSubMenus").change(function () {
            if (this.checked)
                localStorage.setItem("shouldUseSubMenus", "true");
            else
                localStorage.removeItem("shouldUseSubMenus");
            location.reload();
        });
        checkbox.appendTo(menuContainer);
    }
    let extensions = [];
    if (isArabic())
        extensions.push("position-right");
    menuElement.appendTo($("body"));
    let mMenu = {
        slidingSubmenus: !shouldUseSubMenus,
        offCanvas: {
            position: isMobileDevice() ? 'right' : (ts.isArabic() ? 'right' : "left"),
            direction: ts.isArabic() ? 'right' : "left",
        },
        setSelected: {
            hover: shouldFixMenuAsSideBar ? false : true,
            parent: shouldFixMenuAsSideBar ? false : true,
        },
        counters: {
            add: true,
        },
        searchfield: {
            add: true,
            placeholder: ts.translate("search"),
            title: ts.translate("results"),
            noResults: ts.translate("noResults"),
            "clear": true
        },
        navbar: {
            title: ts.translate("main"),
        },
        navbars: [
            {
                content: ["searchfield", "breadcrumbs"],
            }
        ]
    };
    if (shouldFixMenuAsSideBar) {
        mMenu.sidebar = {
            expanded: {
                use: true
            }
        };
        if (isArabic()) {
            $(document).ready(() => {
                $(`<style>
                :root {
                    --mm-min-size: -375px !important;
                    --mm-max-size: -375px !important;
                }
                
                .mm-menu--position-right, .mm-menu--position-right-front, .mm-wrapper--sidebar-expanded .mm-menu--sidebar-expanded {
                    width: 375px !important;
                }
                
                .mm-wrapper--sidebar-expanded.mm-wrapper--opened .mm-slideout {
                    width: calc(100% - 375px) !important;
                }
               </style>`).appendTo($("head"));
            });
        }
    }
    let menu_ = new Mmenu(document.querySelector("#mmenu"),
        mMenu
    );
    menuAPI = menu_.API;
    menuElement.find(".mm-searchfield__input").find("input").attr("placeholder", ts.translateId("search"));
    menuElement.on("click", "a.namaMenuLink", (e) => {
        if (e.target.href) {
            window.location.href = e.target.href;
            menuAPI.close();
        }
    });
}

/**
 *
 * @param menu
 * @param childGroup {namaTypes.DTOMenuGroup}
 * @param childItems_ {namaTypes.DTOMenuItem[]}
 */
function addMenuItems(menu, childGroup, childItems_) {
    for (let childItem of childItems_) {
        if (!childItem || !childItem.target)
            continue;
        if (areEqual(MenuTargetType.AllReports, childItem.target.type)) {
            addAllReports(childGroup);
        } else if (areEqual(MenuTargetType.UserFavourites, childItem.target.type)) {
            addUserFavourites(menu, childGroup);
        } else if (areEqual(MenuTargetType.AutoDashBoards, childItem.target.type)) {
            addAutoDashBoardsGroups(childGroup, childItem);
        } else if (areEqual(MenuTargetType.DashboardsGroup, childItem.target.type)) {
            addAllDashboardsOf(childGroup, childItem, getDashboardsOfGroup(fetchTargetRecord(childItem)));
        } else {
            addItemToGroup(childGroup, childItem);
        }
    }
}

function addItemToGroup(group, item) {
    if (!group.subItems)
        group.subItems = [];
    if (itemCanBeShown(group, item))
        group.subItems.push(item);
}

function addAutoDashBoardsGroups(dashboardGroup, menuItem) {
    let autoDashBoardGroups = getAutoDashBoardGroups();
    if (isEmptyOrNull(autoDashBoardGroups))
        return;
    for (let group of autoDashBoardGroups) {
        addAllDashboardsOf(dashboardGroup, menuItem, getDashboardsOfGroup(group));
    }
}

function addAllDashboardsOf(dashboardGroup, menuItem, dashboards) {
    if (isEmptyOrNull(dashboards))
        return;
    for (let dashboard of dashboards) {
        let place = new places.WelcomePlace();
        place.dashBoardId = dashboard.id.replaceAll("-", "");
        place.src = menuItem.code + dashboard.id.replaceAll("-", "");
        let name = dashboard ? calcByLanguage(dashboard.name1, dashboard.name2) : "";
        let item = {
            id: menuItem.code + place.dashBoardId,
            title: name,
            menuGroup: dashboardGroup,
            place: place
        };
        addItemToGroup(dashboardGroup, item);
    }
}

function addAllReports(reportsSubGroup) {
    let rootReportGroups = getRootReportGroups();
    if (!rootReportGroups)
        return;
    for (let rootReport of rootReportGroups) {
        let name = rootReport ? calcByLanguage(rootReport.name1, rootReport.name2) : "";
        let item = {
            id: rootReport.id,
            title: name
        };
        item.target = {
            targetRecord: rootReport,
            type: MenuTargetType.ReportsGroup,
            targetEntity: BSEntities.ReportDefinition

        };
        addItemToGroup(reportsSubGroup, item);
    }
}

function addUserFavourites(menu, childGroup) {
    let parentGroupCode = childGroup.parentCode;
    let favourites = currentLoginInfo().favourites;
    if (!favourites || !favourites.favouriteItems)
        return;
    for (let i = 0; i < favourites.groupsLines.length; i++) {
        let childGroup = toMenuGroup(favourites.groupsLines[i]);
        childGroup.parentCode = parentGroupCode;
        let items = itemsOf(favourites, childGroup.code);
        if (isEmptyOrNull(items))
            continue;
        menu.groups.push(childGroup);
        for (let item of items)
            addItemToGroup(childGroup, item);
    }
}

function itemsOf(userFavourites, groupCode) {
    return userFavourites.favouriteItems.filter(f => areEqual(groupCode, f.parentGroupCode))
        .filter(l => l.targetFile != null).map(f => toMenuItem(f));
}

/**
 *
 * @param {namaTypes.DTOUserFavouritesLine} userFavourites
 * @return {namaTypes.DTOMenuItem}
 */
function toMenuItem(userFavourites) {
    /**
     *
     * @type {namaTypes.DTOMenuItem}
     */
    let item = {};
    /**
     *
     * @type {namaTypes.DTOMenuTarget}
     */
    item.target = {
        targetRecord: userFavourites.targetFile,
        type: MenuTargetType.Record,
        viewName: userFavourites.viewName || ""

    };
    item.groupCode = userFavourites.parentGroupCode;
    item.code = userFavourites.parentGroupCode + "-" + getFirstNotEmptyObj(userFavourites.targetFile.code, userFavourites.targetFile.altCode,
        userFavourites.targetFile.entityType)
    if (areAllEmptyOrNull(userFavourites.targetFile.code, userFavourites.targetFile.id, userFavourites.targetFile.altCode)) {
        item.target.targetEntity = userFavourites.targetFile.entityType;
        item.target.type = MenuTargetType.NewRecord;
    } else if (areEqual(userFavourites.targetFile.entityType, BSEntities.DashBoard)) {
        item.target.type = MenuTargetType.Dashboard;
    } else if (areEqual(userFavourites.targetFile.entityType, BSEntities.ReportDefinition)) {
        item.target.type = MenuTargetType.Report;
    } else if (areEqual(userFavourites.targetFile.entityType, BSEntities.ReportGroup)) {
        item.target.type = MenuTargetType.ReportsGroup;
    } else if (areEqual(userFavourites.targetFile.entityType, BSEntities.DashBoardGroup)) {
        item.target.type = MenuTargetType.DashboardsGroup;
    }
    if (areEqual(userFavourites.elementType, "CreateNew")) {
        item.target.type = MenuTargetType.NewRecord;
    } else if (areEqual(userFavourites.elementType, "ListView")) {
        item.target.type = MenuTargetType.EntityList;
    }
    return item;
}

/**
 *
 * @param {namaTypes.DTOUserFavouritesGroupsLine} favouriteLine
 */
function toMenuGroup(favouriteLine) {
    /**
     *
     * @type {DTOMenuGroup}
     */
    let group = {
        code: favouriteLine.code,
        titleId: favouriteLine.code,
        name1: favouriteLine.name1,
        name2: favouriteLine.name2
    };
    return group;
}

/**
 *
 * @param group {namaTypes.DTOMenuGroup}
 * @param item {namaTypes.DTOMenuItem}
 * @returns {boolean}
 */
function itemPreventedBySecurityProfile(group, item) {
    if (!item)
        return false;
    let currentUser = currentLoginInfo().userInfo;
    if (currentUser == null)
        return false;
    if (!currentUser.fullProfile)
        return false;
    if (isEmptyOrNull(currentUser.fullProfile.allowDisallowInMenus))
        return false;
    if (menuItemAllowedByCode(currentUser, item))
        return false;
    if (menuItemDisallowedByCode(currentUser, item))
        return true;
    if (!item.target)
        return false;
    if (isEmptyOrNull(item.target.targetEntity))
        return false;


    let allowed = calcAllowedOrDisallowedLinesFor(item.target.targetEntity, "Allow", currentUser);
    let disallowed = calcAllowedOrDisallowedLinesFor(item.target.targetEntity, "Prevent", currentUser);
    if (disallowed.filter(l => areEqual(group.code, l.groupCode)).length)
        return true;
    if (allowed.filter(l => areEqual(group.code, l.groupCode)).length)
        return false;
    if (allowed.filter(l => areEqual(group.parentCode, l.groupCode)).length)
        return false;
    if (disallowed.filter(l => areEqual(group.parentCode, l.groupCode)).length)
        return true;
    return false;
}

function menuItemAllowedByCode(currentUser, item) {
    return currentUser.fullProfile.allowDisallowInMenus
        .filter(l => l.elementCode === item.code && l.allowDisallow === "Allow").length > 0;
}

function menuItemDisallowedByCode(currentUser, item) {
    return currentUser.fullProfile.allowDisallowInMenus
        .filter(l => l.elementCode === item.code && l.allowDisallow === "Prevent").length > 0;
}

function calcAllowedOrDisallowedLinesFor(entity, allowOrDisallow, currentUser) {
    return currentUser.fullProfile.allowDisallowInMenus
        .filter(l => ifTypeApplied(entity, l, allowOrDisallow));
}

function ifTypeApplied(entity, l, allowOrDisallow) {
    if (isNotEmptyOrNull(l.elementCode))
        return false;
    if (areNotEqual(allowOrDisallow, l.allowDisallow))
        return false;
    if (areEqual(l.entityType, entity))
        return true;
    if (!l.entityTypeList)
        return false;
    let type = l.entityTypeList[DomainBaseFieldIDs.EntityTypeList_lines_entityType] || "";
    if (type.contains(entity + ","))
        return true;
    return false;
}

/**
 *
 * @param {namaTypes.DTOMenuDefinition} menu
 * @return {Array}
 */
function constructMenuTree(menu) {
    let rootGroups = [];
    for (let i = 0; i < menu.groups.length; i++) {
        let g = menu.groups[i];
        if (g.rootGroup) {
            if ((isModuleLoaded(g.relatedToModule) || isModuleNotEmptyAndLoaded(g.relatedToSubModule)) && isFeatureEnabled(g.relatedToFeature))
                rootGroups.push(g);
        } else {
            let parentRoot = findParentGroup(g.parentCode, menu.groups);
            if (parentRoot) {
                if (!parentRoot.subGroups)
                    parentRoot.subGroups = [];
                if ((isModuleLoaded(g.relatedToModule) || isModuleNotEmptyAndLoaded(g.relatedToSubModule)) && isFeatureEnabled(g.relatedToFeature))
                    parentRoot.subGroups.push(g);
            }
        }
    }
    return rootGroups;
}

/**
 *
 * @param  {namaTypes.DTOMenuGroup} group
 * @param  {namaTypes.DTOMenuItem} item
 */
function itemCanBeShown(group, item) {
    if (itemPreventedBySecurityProfile(group, item))
        return false;
    if (!item.target)
        return true;
    if (isAnyEqualToFirst(item.target.type, MenuTargetType.UserFavourites, MenuTargetType.AllReports, MenuTargetType.DashboardsGroup))
        return true;
    let place = createPlaceOrLinkForMenuItem(item);
    if (!place)
        return false;
    if (typeof place === "string")
        return true;
    return place.isAllowedInCurrentSecurityProfile();
}

function renderGroup(group, appendTo) {
    let rootElement = $(`<li><span>${ts.translateMenuGroup(group)}</span></li>`);
    let containerElement = $("<ul/>");
    let subGroups = group.subGroups || [];
    for (let subGroup of subGroups)
        renderGroup(subGroup, containerElement)
    let subItems = group.subItems || [];
    for (let subItem of subItems)
        renderMenuItem(subItem, containerElement);
    if (containerElement.find("li").length) {
        containerElement.appendTo(rootElement);
        rootElement.appendTo(appendTo);
    }
}

function childGroups(menu, groupCode) {
    return menu.groups.filter((g) => g.parentCode === groupCode);
}

function childItems(menu, groupCode) {
    return menu.items.filter(item => item.groupCode === groupCode);
}

function expandGroupsIfAutoDashboards(groups, menu) {
    let autoDashBoardGroups = getAutoDashBoardGroups();
    if (isEmptyOrNull(autoDashBoardGroups))
        return;
    for (let i = groups.length - 1; i >= 0; i--) {
        /**
         * @type {namaTypes.DTOMenuGroup}
         */
        let group = groups[i];
        let items = childItems(menu, group.code);
        if (!items || items.length != 1)
            continue;
        let autoDashBoards = items.filter(it => fetchTargetType(it) === MenuTargetType.AutoDashBoards) || [];
        let autoDashboard = isNotEmptyOrNull(autoDashBoards) ? autoDashBoards[0] : null;
        if (!autoDashboard)
            continue;
        menu.items.splice(menu.items.indexOf(autoDashboard), 1);
        groups.splice(groups.indexOf(group), 1);
        for (let ag of autoDashBoardGroups) {
            /**
             *
             * @type {namaTypes.DTOMenuGroup}
             */
            let g = {};
            g.code = group.code + ag.code;
            g.name1 = ag.name1;
            g.name2 = ag.name2;
            g.id = ag.id;
            g.rootGroup = false;
            g.parentCode = group.parentCode;
            groups.push(g);
            menu.groups.push(g);
            /**
             *
             * @type {namaTypes.DTOMenuItem}
             */
            let item = {};
            item.id = ag.id;
            item.code = g.code;
            item.groupCode = g.code;
            item.target = {
                targetRecord: ag,
                type: MenuTargetType.DashboardsGroup
            };
            menu.items.push(item);
        }

    }
}

export let menuItemsMap = new Map();

/**
 *
 * @param {namaTypes.DTOMenuItem} item
 * @param appendTo
 */
function renderMenuItem(item, appendTo) {
    let placeOrLink = createPlaceOrLinkForMenuItem(item);
    let place = placeOrLink;
    let link = placeOrLink;
    if (place && typeof place !== "string")
        link = place.fullLink();
    let id = nextId();
    menuItemsMap.set(place, id);
    let itemElement = $(`<li><a id ="${id}" extraSearch="${calcMenuItemSearchStr(item)}" class='namaMenuLink' href="${link}">${translateMenuItem(item)}</a></li>`);
    itemElement.appendTo(appendTo);
}

/**
 *
 * @param item
 * @return {string|NamaPlace}
 */
function createPlaceOrLinkForMenuItem(childItem) {
    if (!childItem.target && childItem.place)
        return childItem.place;
    switch (childItem.target.type) {
        case MenuTargetType.EntityList:
            return createListPlace(childItem);
        case MenuTargetType.Record:
            return createEditPlace(childItem);
        case MenuTargetType.NewRecord:
            return createNewPlace(childItem);
        case MenuTargetType.Report: {
            let place = new places.ReportLauncherPlace("");
            place.reportId = childItem.target.targetRecord.id;
            return place;
        }
            break;
        case MenuTargetType.ReportsGroup: {
            let place = new places.ListReportPlace({src: childItem.code});
            let targetRecord = childItem.target.targetRecord;
            place.currentRoot = targetRecord.id;
            place.rootType = targetRecord.entityType;
            place.src = targetRecord.id;
            place.showTree = true;
            return place;
        }
            break;
        case MenuTargetType.Dashboard:
            if (childItem.target.targetRecord) {
                let place = new places.WelcomePlace();
                place.dashBoardId = childItem.target.targetRecord.id;
                return place;
            }
            break;
        case MenuTargetType.InternalLink:
        case MenuTargetType.Link:
            return childItem.target.link;
    }
    return null;
}

function translateMenuItem(childItem, otherLang) {
    if (otherLang)
        ts.switchLang();
    let title = ts.translateMenuItem(childItem, otherLang);
    if (title && title.length) {
        ts.restoreLang();
        return title;
    }
    if (!childItem.target) {
        return childItem.title;
    }
    switch (childItem.target.type) {
        case MenuTargetType.AllReports:
            break;
        case MenuTargetType.EntityList:
            title = ts.getListViewTitle(childItem.target.targetEntity, childItem.target.viewName, null, childItem);
            break;
        case MenuTargetType.NewRecord:
            title = ts.translateId(childItem.target.targetEntity);
            break;
        case MenuTargetType.Report:
        case MenuTargetType.Dashboard:
        case MenuTargetType.ReportsGroup:
        case MenuTargetType.Record:
            title = ts.translateRef(childItem.target.targetRecord);
            break;
        case MenuTargetType.InternalLink:
        case MenuTargetType.Link:
            title = childItem.target.link;
            break;
    }
    ts.restoreLang();
    return title;
}

function calcMenuItemSearchStr(childItem) {
    let title = translateMenuItem(childItem, false);
    let title2 = translateMenuItem(childItem, true);

    if (!childItem.target) {
        return title + " " + title2 + (childItem.title && childItem.title.id ? childItem.title.id : "");
    }
    switch (childItem.target.type) {
        case MenuTargetType.AllReports:
            break;
        case MenuTargetType.EntityList:
            title += " " + childItem.target.targetEntity;
            title += " " + ts.translateId(childItem.target.targetEntity);
            title2 += " " + ts.translateIdInOtherLang(childItem.target.targetEntity);
            break;
        case MenuTargetType.NewRecord:
            title += " " + childItem.target.targetEntity + "s";
            title += " " + ts.translateId(childItem.target.targetEntity + "s");
            title2 += " " + ts.translateIdInOtherLang(childItem.target.targetEntity + "s");
            break;
        case MenuTargetType.Report:
        case MenuTargetType.Dashboard:
        case MenuTargetType.ReportsGroup:
        case MenuTargetType.Record:
            title += " " + childItem.target.targetRecord ? childItem.target.targetRecord.code : "";
            title2 = " " + childItem.target.targetRecord ? getFirstNotEmptyObj(childItem.target.targetRecord.code, childItem.target.targetRecord.altCode) : "";
            break;
    }
    return title + " " + title2;
}

function findParentGroup(code, groups) {
    for (let i = 0; i < groups.length; i++)
        if (groups[i].code === code)
            return groups[i];
    return null;
}

function createListPlace(item) {
    let place = new places.EntityListPlace({src: item.code});
    let target = item.target;
    place.entityType = target.targetEntity;
    place.listViewName = target.viewName;
    return place;
}

function createEditPlace(item) {
    let place = new places.EditPlace({src: item.code});
    let target = item.target;
    place.entityType = target.targetEntity;
    place.editViewName = target.viewName;
    place.view = ViewMode.EDIT;
    if (target.targetRecord && target.targetRecord.id) {
        place.src = target.targetRecord.code;
        place.id = target.targetRecord.id;
        place.entityType = target.targetRecord.entityType;
    }
    return place;
}

function createNewPlace(item) {
    let place = new places.EditPlace({src: item.code});
    let target = item.target;
    place.entityType = target.targetEntity;
    place.editViewName = target.viewName;
    place.view = ViewMode.NEW;
    return place;
}